import "./Products.module.css";
import Header from "@/reusable_sections/Header";
import PremiumTradeCatalog from "./sections/PremiumTradeCatalog";
import SustainableSolutionsShowcase from "./sections/SustainableSolutionsShowcase";
import Footer from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <Header />
      <PremiumTradeCatalog />
      <SustainableSolutionsShowcase />
      <Footer />
    </div>;
}